/* SharkGuard variant picker.
   Matches the selected options to a variant, keeps the hidden id in step, greys
   out combinations that are not buyable, and tells the section what changed. */
(function () {
  function init(box) {
    if (box.dataset.sgReady) return;
    box.dataset.sgReady = '1';

    var variants = [];
    try { variants = JSON.parse(box.dataset.variants || '[]'); } catch (e) { return; }
    var vid = box.querySelector('[data-sg-vid]');
    var radios = [].slice.call(box.querySelectorAll('[data-sg-opt]'));

    function chosen() {
      var out = [];
      radios.forEach(function (r) { if (r.checked) out[+r.dataset.sgOpt] = r.value; });
      return out;
    }

    function find(sel) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
      });
    }

    function paintAvailability(sel) {
      radios.forEach(function (r) {
        var i = +r.dataset.sgOpt;
        var probe = sel.slice();
        probe[i] = r.value;
        var match = variants.filter(function (v) {
          return v.options.every(function (o, k) { return probe[k] == null || o === probe[k]; });
        });
        var ok = match.some(function (v) { return v.available; });
        r.closest('label').classList.toggle('out', !ok);
      });
    }

    function update() {
      var sel = chosen();
      var v = find(sel);
      paintAvailability(sel);

      var name = box.querySelector('[data-sg-swatchname]');
      if (name) {
        var swatchRadio = radios.filter(function (r) {
          return r.checked && r.closest('label').classList.contains('sw');
        })[0];
        if (swatchRadio) name.textContent = swatchRadio.value;
      }

      if (vid) vid.value = v ? v.id : '';
      box.dispatchEvent(new CustomEvent('sg:variant', {
        bubbles: true,
        detail: v ? { id: v.id, price: v.price, available: v.available, options: v.options }
                  : { id: null, price: null, available: false, options: sel }
      }));
    }

    // commercial buyers want the long lengths, so start on the longest that is buyable
    if (box.hasAttribute('data-prefer-longest')) {
      var lengthRadios = radios.filter(function (r) { return /(\d+(?:\.\d+)?)\s*m\b/i.test(r.value); });
      var best = null, bestN = -1;
      lengthRadios.forEach(function (r) {
        var n = parseFloat(/(\d+(?:\.\d+)?)\s*m\b/i.exec(r.value)[1]);
        var probe = chosen(); probe[+r.dataset.sgOpt] = r.value;
        var ok = variants.some(function (v) {
          return v.available && v.options.every(function (o, k) { return probe[k] == null || o === probe[k]; });
        });
        if (ok && n > bestN) { bestN = n; best = r; }
      });
      if (best) best.checked = true;
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  function boot() { document.querySelectorAll('[data-sg-picker]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
}());
